import React, { useState } from 'react';
import { Box, Button, Paper, Typography, Alert } from '@mui/material';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../services/firebase';

const provider = new GoogleAuthProvider();

const Login: React.FC = () => {
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleGoogleLogin = async () => {
    setError('');
    try {
      await signInWithPopup(auth, provider);
      navigate('/discover');
    } catch (err: any) {
      setError(err.message || 'Google login failed');
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundImage: 'url(/images/login-hero.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <Paper
        elevation={12}
        sx={{
          p: { xs: 2, sm: 5 },
          maxWidth: 400,
          width: '100%',
          backgroundColor: 'rgba(5, 8, 20, 0.92)',
          backdropFilter: 'blur(16px)',
          border: '1px solid rgba(245, 158, 11, 0.3)',
          boxShadow: '0 0 40px rgba(0,0,0,0.8), 0 0 0 1px rgba(245,158,11,0.15)',
        }}
      >
        <Typography variant="h3" fontWeight={800} gutterBottom sx={{ color: '#F59E0B', letterSpacing: '-0.5px' }}>
          Pryvo
        </Typography>
        <Typography variant="body1" mb={4} sx={{ color: 'rgba(255,255,255,0.75)', fontStyle: 'italic' }}>
          Pry into volatility. Find your edge.
        </Typography>

        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

        <Box sx={{ mt: 1 }}>
          <Button variant="contained" fullWidth onClick={handleGoogleLogin}>
            Sign in with Google
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default Login;
